import { object, string } from 'yup';
const formSpec = {
    giftVoucher: string()
        .required('This field is required')
        .min(12, 'The gift voucher must be exactly 12 characters long.')
        .max(12, 'The gift voucher must be exactly 12 characters long.'),
};
export const giftVoucherFormSchema = object(formSpec);
